"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewTerminalStatuses = void 0;
exports.ReviewTerminalStatuses = ['complete', 'failed', 'cancelled'];
//# sourceMappingURL=review-terminal-status.js.map